import { RankedUserStateType } from './BaseRankedUserState.ts';
import { RankedPlacementState } from './RankedPlacementState.ts';
import { RankedMMRState } from './RankedMMRState.ts';
import { RankedLockedState } from './RankedLockedState.ts';
export class RankedUserStateController {
    static deserialize(data) {
        switch(data.type){
            case RankedUserStateType.Placement:
                return RankedPlacementState.deserialize(data);
            case RankedUserStateType.Ranked:
                return RankedMMRState.deserialize(data);
            case RankedUserStateType.RankedLocked:
                return RankedLockedState.deserialize(data);
        }
    }
}
